import { module as Module } from "modujs";
import { whenReady } from "../utils/fonts";
import {FONT} from "../config.js";
import {$screen} from "../stores/screen.js";
import { $html } from "../utils/dom.js";

export default class extends Module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this);
    }

    ///////////////
    // Lifecycle
    ///////////////
    init() {
        this.bindEvents();

        if(!$html.classList.contains('has-quicknav-visible') && $html.classList.contains('is-changing')) this.el.classList.add('-animate');

        whenReady(FONT.EAGER).then((fonts) => this.onFontsLoaded(fonts));
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.unbindScreenListener = $screen.subscribe(this.onResizeBind)
    }

    unbindEvents() {
        this.unbindScreenListener?.()
    }

    onInview(e) {
        $html.classList.toggle('has-quicknav-visible', e.way == 'enter')
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.compute();
    }

    onFontsLoaded(fonts) {
        this.compute();
    }

    compute() {
        requestAnimationFrame(() => {
            const height = this.el.offsetHeight
            document.documentElement.style.setProperty('--quicknav-height', `${height}px`);
        })
    }
}
